import { render, staticRenderFns } from "./PublicationTimestamp.vue?vue&type=template&id=99bb0d7e&"
import script from "./PublicationTimestamp.vue?vue&type=script&lang=js&"
export * from "./PublicationTimestamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports